export default "__VITE_ASSET__CPTnVJdg__"